

define(['squid/index', 'text!./template.html', './opinionlab', './footerMap', 'components/xo-models/src/checkout/index', 'components/xo-ui-components/src/modal/directive', 'components/xo-return-to-merchant/dist/util', 'components/xo-ui-components/src/escape-hatch/escapeHatch/directive', 'components/xo-device-info/dist/index', 'components/xo-form-components/src/language-options/directive', 'components/xo-models/src/user/index'], function (squid, template, opinionlab, footerMap) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-footer.directive', ['squid', 'xomodel.checkout', 'xo-modal.directive', 'xo-return-to-merchant', 'xo-escape-hatch.escapeHatch.directive', 'xo-device-info', 'xo-language-options.directive', 'xomodel.user']).factory('$GetPomaFlowStatus', function ($pxp, $q) {
        return function (country) {
            return $pxp('XO_XOONBOARDING_POMA_GLOBAL', { 'ctx.COUNTRY': country }, 'XO_XOONBOARDING_POMA_GLOBAL_TREATMENT').then(function (result) {
                if (result && result.treatment_name) {
                    return $q.resolve(true);
                } else {
                    return $q.resolve(false);
                }
            });
        };
    }).directive('xoFooter', function () {

        return {
            template: template,
            restrict: 'EA',
            scope: {
                token: '=',
                escapeHatchIncontext: '=',
                cancel: '@',
                merchant: '@',
                languageSwitch: '=?'
            },
            controller: function controller($scope, $populate, $rootScope, $CheckoutAppDataModel, $ReturnToMerchant, $util, $locale, $window, $DeviceInfo, $feature, $config, $state, $CheckoutInputDataModel, $GetPomaFlowStatus, $logger) {

                $scope.isIFrame = $util.isIFrame();
                if ($scope.escapeHatchIncontext) {
                    $scope.showEscapeHatch = $scope.isIFrame;
                }
                $scope.locale = $locale;
                $scope.proxSignUpFlow = $CheckoutInputDataModel.instance($scope.token).isEbayTxn();
                $scope.year = new Date().getFullYear();

                $scope.isApac = function () {
                    return $config.apacCountries && $config.apacCountries.indexOf($scope.locale.country) > -1;
                };

                // Determine if country belongs to a region to serve correct footer links
                var getRegion = function getRegion(country) {
                    var regions = $config.regions;
                    for (var region in regions) {
                        if (regions[region].indexOf(country) > -1) {
                            return region;
                        }
                    }

                    return false;
                };

                $scope.footerLinks = function () {
                    if ($scope.isApac()) {
                        return footerMap.APAC;
                    }

                    return footerMap[$scope.locale.country] || footerMap[getRegion($scope.locale.country)] || footerMap.DEFAULT;
                };

                $scope.showPolicyInfo = function () {
                    return $scope.isApac() || $scope.locale.country === 'AU';
                };

                $scope.cancelRedirect = function ($event) {
                    $event.preventDefault();

                    $GetPomaFlowStatus($scope.locale.country).then(function (poma_flag) {
                        var currentRoute = $state.current;
                        var routeName = (currentRoute ? currentRoute.name : 'noRoute').replace(/\./g, '_');
                        var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;

                        if (poma_flag) {
                            state = 'guest_POMA';
                        }

                        $logger.info('checkout_fpti', {
                            'from': state,
                            'to': 'process_cancel_and_return_to_merchant'
                        });

                        $ReturnToMerchant.goTo($scope.cancel);
                    });
                };

                if ($scope.token) {
                    $populate($scope, {
                        checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
                    }).then(function () {
                        var merchant = $scope.checkoutAppData.merchant;
                        $scope.cancel = $scope.checkoutAppData.urls.cancel_url;
                        $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;

                        // for ebay transactions, override the merchant name to ebay instead of the actual merchant.
                        if ($scope.proxSignUpFlow) {
                            $scope.merchant = $locale.content.signup.ebay;
                        }
                    });
                }

                var cancelShowModal = $rootScope.$on('showModal', function (event, config) {
                    $scope.popupUrl = config && config.popupUrl;
                    $scope.show = true;
                    $scope.$digest(); // eslint-disable-line angular/ng_no_digest
                });

                $scope.$on('$destroy', cancelShowModal);

                $scope.showOL = function showOL(event) {
                    event.preventDefault();

                    var placeholder = 'main:ec:hermes';
                    var page = $state.current.get('trackingData.buzname.fullpage.pagename2', 'unknown').replace('%', placeholder);

                    var data = {
                        opVars: {
                            rlogId: $window.meta.rlogId || '',
                            page: page || window.location.hash,
                            csci: 'Unknown',
                            calc: $window.meta.correlationId,
                            custId: 'Unknown',
                            merchantId: 'Unknown',
                            token: $scope.token || 'Unknown'
                        },
                        locale: {
                            country: $locale.country,
                            languageCode: $locale.lang + '_' + $locale.country
                        }
                    };

                    opinionlab(data);
                };

                $scope.showFeedback = function () {
                    if ($DeviceInfo.isDevice()) {
                        return false;
                    }
                    return true;
                };

                $scope.hideReturnCancelUrl = function () {
                    return !$scope.cancel || $state.current && $state.current.name === 'checkout.done';
                };
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/footer/directive.js
// module id = ./components/xo-page-components/src/footer/directive.js
// module chunks = 1